<template>
  <svg
    width="20px"
    height="13px"
    viewBox="0 0 20 13"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 63.1 (92452) - https://sketch.com -->
    <title>{{ title }}</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <polygon id="path-1" points="17.5 0.375 10 7.575 2.5 0.375 0 2.775 10 12.375 20 2.775" />
    </defs>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Icon-/-Arrow-down-/-rollover">
        <g id="Icon-2">
          <mask id="mask-2" fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <use id="Icon-Copy-2" fill="#2f477c" xlink:href="#path-1" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Expand',
    },
  },
};
</script>
